// extracted by mini-css-extract-plugin
var _1 = "VersionChangesWallAuthorCard-module__animatedBackground--sK_qz";
var _2 = "VersionChangesWallAuthorCard-module__asPopOver--Apwac";
var _3 = "VersionChangesWallAuthorCard-module__authorName--fqCTH";
var _4 = "VersionChangesWallAuthorCard-module__avatar--Tqd18";
var _5 = "VersionChangesWallAuthorCard-module__button--drjhV";
var _6 = "VersionChangesWallAuthorCard-module__card--Dsxdh";
var _7 = "VersionChangesWallAuthorCard-module__content--B9ovj";
var _8 = "VersionChangesWallAuthorCard-module__date--pmFhC";
var _9 = "VersionChangesWallAuthorCard-module__isFocused--QnOaM";
var _a = "VersionChangesWallAuthorCard-module__isMenuOpen--QSGqq";
var _b = "VersionChangesWallAuthorCard-module__menu--QJWXH";
var _c = "274px";
var _d = "VersionChangesWallAuthorCard-module__popOver--EBBVZ";
var _e = "VersionChangesWallAuthorCard-module__wrapper--GVaiC";
export { _1 as "animatedBackground", _2 as "asPopOver", _3 as "authorName", _4 as "avatar", _5 as "button", _6 as "card", _7 as "content", _8 as "date", _9 as "isFocused", _a as "isMenuOpen", _b as "menu", _c as "normalWidth", _d as "popOver", _e as "wrapper" }
